
import React from 'react';
// import './Footer.css';
import { FaFacebookF, FaLinkedinIn, FaWhatsapp, FaEnvelope } from 'react-icons/fa';
import { FaPhoneAlt, FaMapMarkerAlt } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        <div className="footer-column">
          <h2 className="footer-heading">ERP Pro Solutions</h2>
          <p className='p'>Your trusted ERP <br></br>
           partner for <br></br>
            smarter business <br></br> operations.</p>
          {/* <div className="footer-social-icons">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><FaFacebookF className='icon' size={26} /></a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><FaLinkedinIn className='icon' size={26} /></a>
            <a href="https://wa.me/1234567890" target="_blank" rel="noopener noreferrer"><FaWhatsapp className='icon' size={26} /></a>
            <a href="mailto:support@erppro.com"><FaEnvelope className='icon' size={26} /></a>
          </div> */}
        </div>

        <div className="footer-column">
          <h4 className="footer-subheading">Quick Links</h4>
          <ul className="footer-list">
            <li><a href="/">Home</a></li>
            <li><a href="/about">About Us</a></li>
            <li><a href="/services">Our Services</a></li>
            <li><a href="/contact">Contact Us</a></li>
            <li><a href="/careers">Careers</a></li>
          </ul>
        </div>

        <div className="footer-column">
          <h4 className="footer-subheading">ERP Modules</h4>
          <ul className="footer-list">
            <li><a href="/modules/hr">HR Management</a></li>
            <li><a href="/modules/inventory">Inventory</a></li>
            <li><a href="/modules/finance">Finance</a></li>
            <li><a href="/modules/sales">Sales & CRM</a></li>
            <li><a href="/modules/support">Support</a></li>
          </ul>
        </div>

        <div className="footer-column">
          <h4 className="footer1-subheading">Contact Us</h4><br></br>
          <p className='contact1'><FaPhoneAlt /> 
          <span>+91-9876543210</span></p>
          <p className='contact1'><FaEnvelope />
          <span>&nbsp;support@erppro.com</span></p>
          <p className='contact1'> <FaMapMarkerAlt />
          <span>123 ERP Street, Bhopal, India</span></p>
        </div>


        <div className="footer-column">
          <h4 className="footer1-subheading">Social Media</h4><br></br>
          <div className="footer-social-icons">
            <a className='ac' href="https://facebook.com" target="_blank" rel="noopener noreferrer"><FaFacebookF className='icon' size={26} /></a><br></br>
            <a className='ac' href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><FaLinkedinIn className='icon' size={26} /></a><br></br>
            <a className='ac' href="https://wa.me/1234567890" target="_blank" rel="noopener noreferrer"><FaWhatsapp className='icon' size={26} /></a><br></br>
            <a className='ac' href="mailto:support@erppro.com"><FaEnvelope className='icon' size={26} /></a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        © {new Date().getFullYear()} ERPPro Solutions. All rights reserved.
        <span>
          <a href="/terms" className="footer-legal-link">Terms</a> | 
          <a href="/privacy" className="footer-legal-link"> Privacy</a>
        </span>
      </div>
    </footer>
  );
};

export default Footer;
